export default __webpack_public_path__ + "static/media/slack.c3616124.svg";